import FuelCanisterGauge from "../../../../components/FuelCanisterGauge.js";
import { useState, useRef, useLayoutEffect, useEffect } from "react";
import { useSelector } from "react-redux";


const MainPageLeftSide = () => {
 
  /////////////////////////////////////////////////////redux states
  
  const tierState = useSelector((state) => state.tierState);

  /////////////////////////////////////////////////////local states
  const [radius, setRadius] = useState();

  /////////////////////////////////////////////////////variables derived from redux state

  /////////////////////////////////////////////////////refs
  const containerRef = useRef();

  /////////////////////////////////////////////////////local variables
  let resizeTimer;

  /////////////////////////////////////////////////////methods
  const calculateGaugeRadius = () => {
    const div = containerRef.current;
    const style = getComputedStyle(div);
    const currentWidth =
      div.clientWidth -
      parseInt(style.marginLeft) -
      parseInt(style.marginRight);
    const maxRadius = 400;

    if (currentWidth > maxRadius) {
      return maxRadius;
    }

    return currentWidth;
  };

  /////////////////////////////////////////////////////handling functions
  const handleResize = () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      setRadius(calculateGaugeRadius());
    }, 50);
  };

  /////////////////////////////////////////////////////effects
  useLayoutEffect(() => {
    setRadius(calculateGaugeRadius());
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /////////////////////////////////////////////////////render
  return (
    <div
      ref={containerRef}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      {tierState.tiers.length > 0 && (
        <>
          <FuelCanisterGauge
            radius={radius}
          />
        </>
      )}
    </div>
  );
};

export default MainPageLeftSide;
